import { useEffect, useState } from 'react';
import { userInfo as resolveUserInfo } from 'reporting-data/request/user-info';
import { AsyncStatus, isFailed, isLoading, isSucceeded } from '../utils/async-data-utils';
export const useUserInfo = () => {
  const [requestState, setRequestState] = useState({
    status: AsyncStatus.UNINITIALIZED
  });
  useEffect(() => {
    let expired = false;
    setRequestState(state => Object.assign({}, state, {
      status: AsyncStatus.PENDING
    }));
    resolveUserInfo().then(newUserInfo => {
      if (!expired) {
        setRequestState({
          status: AsyncStatus.SUCCEEDED,
          data: newUserInfo
        });
      }
    }).catch(error => {
      if (!expired) {
        setRequestState({
          status: AsyncStatus.FAILED,
          error
        });
      }
    });
    return () => {
      expired = true;
    };
  }, []);
  return {
    loading: isLoading(requestState),
    data: isSucceeded(requestState) ? requestState.data : undefined,
    error: isFailed(requestState) ? requestState.error : undefined
  };
};